import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b60a349"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid mr-0 justify-content-center" }
const _hoisted_2 = { class: "col-11 pt-3" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  class: "col-12",
  style: {"display":"flex","justify-content":"end"}
}
const _hoisted_6 = { class: "grid" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "col-12 xl:col p-0" }
const _hoisted_9 = {
  key: 0,
  class: "col-12 xl:col-3 p-0"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-0 m-0" }, "Add Items to Cart", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-0 m-0" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-xl text-center" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle text-warning mr-2 text-xl" }),
    /*#__PURE__*/_createTextVNode("You already have items in your cart")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-lg text-center" }, "Would you like to keep them?")
], -1))
const _hoisted_12 = { class: "p-0 m-0 pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataGrid = _resolveComponent("DataGrid")!
  const _component_Card = _resolveComponent("Card")!
  const _component_CollapsibleSection = _resolveComponent("CollapsibleSection")!
  const _component_Steps = _resolveComponent("Steps")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_SideOrder = _resolveComponent("SideOrder")!
  const _component_NotificationCard = _resolveComponent("NotificationCard")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_SendOrderDialog = _resolveComponent("SendOrderDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_LoadingSpinner, { loading: _ctx.isLoadingSales }, null, 8, ["loading"]),
        (_ctx.isLoadingSales)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_CollapsibleSection, {
                isOpen: _ctx.sectionsStatus.pastOrders,
                header: "Order History",
                "onUpdate:isOpen": _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleSectionIcon('pastOrders')))
              }, {
                content: _withCtx(() => [
                  _createVNode(_component_Card, { class: "mb-5 mt-0" }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_Button, {
                          class: "split-sales-order-btn",
                          label: "Print/Export",
                          icon: "pi pi-print",
                          onClick: _ctx.printTable
                        }, null, 8, ["onClick"])
                      ]),
                      _createVNode(_component_DataGrid, {
                        items: _ctx.items,
                        columns: _ctx.columns,
                        breakpoint: "1267px",
                        dataKey: "so_id",
                        order: _ctx.salesOrder,
                        firstRowGetter: "sales/getFirstRow",
                        actions: _ctx.tableActions,
                        filters: _ctx.filters,
                        onOnPageClicked: _ctx.pageClick,
                        onOnSort: _ctx.sortOrders,
                        sortField: _ctx.sort.sortBy,
                        sortOrder: _ctx.sort.sortOrder,
                        onFetchData: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateFilters($event))),
                        rowsPerPage: _ctx.rows,
                        onOnRowsPerPageChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.rows = $event)),
                        class: "p-datatable-sm"
                      }, null, 8, ["items", "columns", "order", "actions", "filters", "onOnPageClicked", "onOnSort", "sortField", "sortOrder", "rowsPerPage"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["isOpen"]),
              _createVNode(_component_Card, null, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_Steps, {
                        class: "custom-steps",
                        model: _ctx.computedSteps,
                        readonly: false
                      }, null, 8, ["model"])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_router_view, {
                        orderSubmitted: this.orderSubmitted
                      }, null, 8, ["orderSubmitted"])
                    ]),
                    (_ctx.$route.fullPath !== '/sales/confirmation')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createVNode(_component_SideOrder, {
                            onOrderCreated: _ctx.handleOrderCreated,
                            onOrderSubmitted: _ctx.handleOrderSubmitted
                          }, null, 8, ["onOrderCreated", "onOrderSubmitted"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]))
      ])
    ]),
    _createVNode(_component_NotificationCard),
    _createVNode(_component_Dialog, {
      visible: _ctx.showReorderConfirmation,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showReorderConfirmation) = $event)),
      modal: "",
      class: "w-6 xl:w-4"
    }, {
      header: _withCtx(() => [
        _hoisted_10
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_Button, {
            label: "Yes",
            icon: "pi pi-check",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleReorderItems(_ctx.addingReorderItems)))
          }),
          _createVNode(_component_Button, {
            label: "No",
            icon: "pi pi-times",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleClearAndReorderItems(_ctx.addingReorderItems)))
          })
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_11
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_SendOrderDialog, {
      title: `Send a copy of Order #${_ctx.orderIdToSend} to:`,
      visible: _ctx.showSendEmailDialog,
      orderId: _ctx.orderIdToSend,
      onOnCloseDialog: _ctx.closeSendEmailDialog,
      onOnSendEmail: _ctx.handleSendEmail,
      loading: _ctx.emailLoading
    }, null, 8, ["title", "visible", "orderId", "onOnCloseDialog", "onOnSendEmail", "loading"])
  ], 64))
}